export const load = () => ({
	title: 'Myths About Energy Efficient Windows',
	showTitle: true,
});
